import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableCardsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const DATA_TABLE_CARD_SKELETON_COUNT = 4;

export const DATA_TABLE_CARD_SKELETON_WIDTHS: Array<`${number}%`> = [
    "56%",
    "40%",
    "72%"
];

const stylesheet = StyleSheet.create({
    summary: {
        justifyContent: "space-between",
        flexDirection: "row"
    },
    container: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    spaces
}: DataTableCardsDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: spaces.spacingMd,
            paddingBottom: spaces.spacingMd,
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        summary: {
            columnGap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        list: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
